import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { CONST_ROL_MASTER } from "../../../../app/constants/constanst-valores";
import { CONST_RUTA_USUARIOS_LISTAR } from "../../../../app/constants/constants-rutas-codigos";
import { obtenerExtensionEImagenBase64 } from "../../../../shared/utils/funciones";
import { usuarioCrear, usuarioEditar } from "../../api/usuarios.api";

// Envío del formulario de usuario (crear / editar) y cancelación.
// Recibe del hook principal el estado y los valores que antes leía por closure.
export const useUsuarioFormEnvio = ({
    sedesSeleccionadas,
    accesosOrg,
    setErrorSedes,
    setMensaje,
    setMostrar,
    rol,
    usuarioAutenticado,
    usuario,
    sucursal1,
    sede1,
    accion,
    watch,
}: any) => {

    const onSubmitCrear = async (data) => {
        // Multi Sede Usuarios: exige al menos una sede seleccionada
        if (sedesSeleccionadas.length === 0) {
            setErrorSedes(true)
            return
        }
        setErrorSedes(false)
        const imagen = await obtenerExtensionEImagenBase64(data?.Imagen[0])
        const dataPOST = {
            ...data,
            ape_pat: data?.ape_pat?.toUpperCase().trim() || "",
            ape_mat: data?.ape_mat?.toUpperCase().trim() || "",
            celular: data?.celular?.toUpperCase().trim() || "",
            compania_pad: data?.compania || "",
            compania: data?.sucursal || "",
            email_lab: data?.email_lab.trim() || "",
            email: data?.email.trim() || "",
            estado: data?.estado || "",
            nombre: data?.nombre?.toUpperCase().trim() || "",
            num_ide: data?.num_ide?.toUpperCase().trim() || "",
            privilegio: rol === CONST_ROL_MASTER ? data?.privilegio : "N",
            // Multi Sede Usuarios: la 1ra sede es la primaria (TMUSE10.SedCod);
            // `sedes` lleva la totalidad (detalle TMUSE20 en el backend).
            sede: sedesSeleccionadas?.[0]?.value || "",
            sedes: sedesSeleccionadas.map(s => s?.value),
            // Accesos por organización: 'S' solo lo configurado; 'N' vuelve a según grupo.
            ...(accesosOrg ? { accesos_org: accesosOrg } : {}),
            sexo: data?.sexo || "",
            telefono: data?.telefono?.toUpperCase().trim() || "",
            tipo_ide: data?.tipo_ide || "",
            token: usuarioAutenticado?.token,
            usuario: data?.usuario?.toUpperCase().trim() || "",
            fecha_ingreso: data?.fingreso,
            fecha_nacimiento: data?.fnacimiento,
            anexo: data?.anexo,
            ip: data?.ip,
            codigo_usuario2: data?.usuariokpc,
            password2: data?.clavekpc,
            area: data?.area,
            id_huella: data?.useridhuella,
            direccion: data?.direccion,
            ubigeo: data?.ubigeo,
            formato_foto: imagen?.Extension || "",
            foto: imagen?.imagenBase64 || "",

        }
        /*const dataIMG ={
            ...data,
            usuario: data?.usuario?.toUpperCase().trim() || "",
            foto: imagen?.imagenBase64 || "",
            num_ide: data?.num_ide?.toUpperCase().trim() || "",
            formato_foto: imagen?.Extension || "",

        }*/
        /*const dataMostrar={
            ...data,
            usuario: data?.usuario?.toUpperCase().trim() || "",
        }*/
        const { status, message } = await usuarioCrear(dataPOST)
        /*const {status1, message1} = await actualizarFoto(dataIMG)
        const{status2,message2,foto}= await mostrarFoto(dataMostrar)


        setMensaje1(message1)
        setImagenMostrar(foto)*/
        setMensaje(message)
        setMostrar(true)
        // status == 1 ? setTipoAlerta("success") : setTipoAlerta("warning")
        if (status === 1) {
            //setTipoAlerta("success")
            Swal.fire({
                title:'Se registro con exito',
                icon:'success',
                timer:2000,
                showConfirmButton:false
            })
            navigate(CONST_RUTA_USUARIOS_LISTAR, {
                state: {
                    codCompania: watch("compania"),
                    codSucursal: watch("sucursal"),
                    codSede: sedesSeleccionadas?.[0]?.value || "",
                }
            })
        } else {
            //setTipoAlerta("warning")
            // REF-ERRORES-ESPECIFICOS (2026-07-14): mostrar el motivo del backend.
            Swal.fire(
                {
                    title:'Ocurrio un error al crear el usuario',
                    text: message || '',
                    icon:'warning',
                    timer:4000,
                    showConfirmButton:false
                }
            )
        }
    }

    const onSubmitEditar = async (data) => {
        // Multi Sede Usuarios: exige al menos una sede seleccionada
        if (sedesSeleccionadas.length === 0) {
            setErrorSedes(true)
            return
        }
        setErrorSedes(false)
        const imagen = await obtenerExtensionEImagenBase64(data?.Imagen[0])
        const dataPOST = {
            ...data,
            num_ide: data?.num_ide.toUpperCase().trim() || "",
            nombre: data?.nombre.toUpperCase().trim() || "",
            ape_pat: data?.ape_pat.toUpperCase().trim() || "",
            ape_mat: data?.ape_mat.toUpperCase().trim() || "",
            telefono: data?.telefono.toUpperCase().trim() || "",
            celular: data?.celular.toUpperCase().trim() || "",
            sexo: data?.sexo || "",
            email_lab: data?.email_lab.trim() || "",
            email: data?.email.trim() || "",
            compania_pad: usuario?.UseCompPad || "",
            compania: usuario?.UseComp || "",
            // Multi Sede Usuarios: 1ra sede = primaria; `sedes` = totalidad (TMUSE20)
            sede: sedesSeleccionadas?.[0]?.value || usuario?.SedCod,
            sedes: sedesSeleccionadas.map(s => s?.value),
            ...(accesosOrg ? { accesos_org: accesosOrg } : {}),
            fecha_ingreso: data?.fingreso,
            fecha_nacimiento: data?.fnacimiento,
            anexo: data?.anexo,
            ip: data?.ip,
            codigo_usuario2: data?.usuariokpc,
            password2: data?.clavekpc,
            area: data?.area,
            id_huella: data?.useridhuella,
            // Se crea dos atributos porque el atributo usuario es una llave primaria de la tabla usuario
            // y para actualizar una llave primaria se necesita tanto el usaurio anterior y el nuevo usuario actualizado
            usuario: usuario?.UseCod || "",
            usuario_nuevo: data?.usuario?.toUpperCase() || "",
            direccion: data?.direccion,
            ubigeo: data?.ubigeo,
            formato_foto: imagen?.Extension,
            foto: imagen?.imagenBase64,
            token: usuarioAutenticado?.token


        }
        //console.log(dataPOST)
        const { status, message } = await usuarioEditar(dataPOST)
        setMostrar(true)
        setMensaje(message)

        //status == 1 ? setTipoAlerta("success") : setTipoAlerta("warning")
        if (status === 1){
            Swal.fire({
                title:'Se actualizo correctamente los datos',
                icon:'success',
                timer:2000,
                showConfirmButton:false
            })
        }else{
            // REF-ERRORES-ESPECIFICOS (2026-07-14): mostrar el motivo del backend.
            Swal.fire(
                {
                    title:'Ocurrio un error al actualizar los datos',
                    text: message || '',
                    icon:'warning',
                    timer:4000,
                    showConfirmButton:false
                }
            )
        }

    }

    const navigate = useNavigate();

    const cancelar = () => {
        if(accion === "agregar"){
            navigate(CONST_RUTA_USUARIOS_LISTAR, {
                state: {
                    codCompania: watch("compania"),
                    codSucursal: sucursal1,
                    codSede: sede1,
                }
            })
        }else{
            navigate(CONST_RUTA_USUARIOS_LISTAR, {
                state: {
                    codCompania: watch("compania"),
                    codSucursal: watch("sucursal"),
                    codSede: sedesSeleccionadas?.[0]?.value || "",
                }
            })
        }

    }

    return { onSubmitCrear, onSubmitEditar, cancelar }
}
